import { NotaDaFatura, saidoParaOMundo } from './avisoDeEdicaoDaFatura';

/**
 * CANCELAR E REABRIR DIZEM O QUE FICA VIVO (10/10/2026).
 *
 * O confirm dizia só "Cancelar esta fatura?" e "Reabrir esta fatura para edicao?". Nenhum dos dois toca no mundo de
 * fora: o servidor não dá baixa no boleto e não cancela a nota. Quem cancelava achava que tinha encerrado a cobrança, e
 * o cliente continuava podendo pagar o boleto vivo no banco. Agora o confirm diz a regra sempre e, quando a fatura tem
 * boleto vivo ou nota autorizada, NOMEIA cada um. Nota não lida é dita como "não consegui conferir", nunca como
 * "não tem".
 */
export type AcaoDeSaida = 'cancelar' | 'reabrir';

export const REGRA_DO_QUE_FICA_VIVO = 'O boleto registrado continua pagável no banco; a NF autorizada não é cancelada.';

export interface ConfirmacaoDeSaida {
  titulo: string;
  mensagem: string;
  /** Algo vivo foi nomeado (ou não deu para conferir as notas). */
  temAlgoVivo: boolean;
}

export function confirmacaoDeSaida(
  acao: AcaoDeSaida,
  inv: { code?: string | null; nossoNumero?: string | null; boletoStatus?: string | null },
  /** null = as notas não foram lidas (a consulta falhou). */
  notas: NotaDaFatura[] | null,
  motivoNotasNaoLidas?: string | null,
): ConfirmacaoDeSaida {
  const codigo = inv.code || 'esta fatura';
  const { notas: autorizadas, boleto } = saidoParaOMundo(inv, notas);
  const linhas: string[] = [];

  if (acao === 'cancelar') {
    linhas.push(`Cancelar ${codigo} não dá baixa no boleto e não cancela a nota fiscal. ${REGRA_DO_QUE_FICA_VIVO}`);
    if (boleto) linhas.push(`Esta fatura tem ${boleto}: o cliente ainda consegue pagá-lo. Peça a baixa em Boletos.`);
    if (autorizadas.length) linhas.push(`Esta fatura tem ${autorizadas.join(', ')} ${autorizadas.length === 1 ? 'autorizada, que continua valendo' : 'autorizadas, que continuam valendo'}: o cancelamento da nota é feito em Notas Fiscais.`);
  } else {
    linhas.push(`${codigo} volta para Rascunho. ${REGRA_DO_QUE_FICA_VIVO}`);
    if (boleto) linhas.push(`Esta fatura tem ${boleto}: ele continua valendo o valor de hoje; se o valor mudar, precisa ser baixado e reemitido.`);
    if (autorizadas.length) linhas.push(`Esta fatura tem ${autorizadas.join(', ')} ${autorizadas.length === 1 ? 'autorizada' : 'autorizadas'}: se o valor mudar, ${autorizadas.length === 1 ? 'a nota precisa' : 'as notas precisam'} ser regerada${autorizadas.length === 1 ? '' : 's'}.`);
  }
  if (notas === null) {
    linhas.push(`Não consegui conferir as notas fiscais desta fatura${motivoNotasNaoLidas ? ` (${motivoNotasNaoLidas})` : ''}: se houver nota autorizada, ela não é cancelada.`);
  } else if (!boleto && !autorizadas.length) {
    linhas.push('Esta fatura não tem boleto registrado nem nota autorizada.');
  }

  return {
    titulo: acao === 'cancelar' ? `Cancelar ${codigo}?` : `Reabrir ${codigo} para edição?`,
    mensagem: linhas.join('\n\n'),
    temAlgoVivo: !!boleto || autorizadas.length > 0 || notas === null,
  };
}
